import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { CommandPalette } from './components/CommandPalette';
import { AnnouncementBanner } from './components/AnnouncementBanner';

import { tr } from '@/i18n';
function PageFallback() {
  return <div className="canvas-dots fixed inset-0" aria-busy="true" />;
}

/** Корень приложения: ленивые страницы и глобальная палитра команд (Ctrl/⌘+K). */
export function RootLayout() {
  return (
    <>
      <a href="#main" className="sr-only z-[2000] rounded-full bg-accent px-4 py-2 text-sm font-medium text-white focus:not-sr-only focus:fixed focus:top-3 focus:left-3">
        {tr("Перейти к содержимому")}
      </a>
      <Suspense fallback={<PageFallback />}>
        <Outlet />
      </Suspense>
      <CommandPalette />
      <AnnouncementBanner />
    </>
  );
}
